import ChoiceResponseMapperBase from './ChoiceResponseMapperBase';

export default class SingleChoiceResponseMapper extends ChoiceResponseMapperBase {
  _unMapFailedResponse(userAnswer: any, answers: any) {
    return [answers[userAnswer[0]].id];
  }
}
